import { inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { filter, pairwise } from 'rxjs';

import { AppState } from './initial-state';

export const onSessionEnd = (callback: () => void) =>
  inject<Store<AppState>>(Store)
    .select((state) => state.auth.isLoggedIn)
    .pipe(
      pairwise(),
      filter(([wasLoggedIn, isLoggedIn]) => wasLoggedIn && !isLoggedIn),
      takeUntilDestroyed()
    )
    .subscribe(() => callback());
